import type { ScreenDefinition } from '../../contracts';
import { DocumentEditor } from './DocumentEditor';
import { DocumentList } from './DocumentList';
export { DocumentEditor, DocumentList };
export const screens: ScreenDefinition[] = [
  { id: 'documents.new', title: 'Neuer Beleg', component: DocumentEditor },
  { id: 'documents.edit', title: 'Beleg ändern', component: DocumentEditor },
  { id: 'documents.list', title: 'Belegliste', component: DocumentList },
  { id: 'documents.orders', title: 'Aufträge', component: DocumentList },
];
